<!-- FLIP-316: rendered here, ahead of the nav in DOM order, so the flex column in
     bottom-nav.component.scss stacks its mobile "tab" state flush against this nav's real
     top edge - see that file's :host comment. Its own fixed round-launcher state (desktop /
     tablet-landscape-touch) is unaffected by this nesting. -->
<app-nova-companion-fab></app-nova-companion-fab>

<nav class="bottom-nav">

  <!-- Home -->
  <a class="nav-item"
     routerLink="/landing-page"
     (click)="trackNavItem('/landing-page', 'BottomNavHomeClicked')"
     [class.active]="isHomeActive()"
     [style.--nav-accent]="'var(--color-skylight)'">
    <!-- Two fixed-src icons toggled via a CSS class (not [hidden] - _icons.scss sets a global
         svg-icon { display: flex }, which as an author style always beats the [hidden] UA default
         regardless of specificity) rather than swapping [src]: angular-svg-icon
         doesn't cancel an in-flight fetch when src changes again before it resolves, so whichever
         variant's request happens to resolve first wins and can stick permanently (visible on a
         fresh page load/refresh, where both requests fire close together). -->
    <svg-icon class="nav-icon home parchment" [class.icon-hidden]="!isHomeActive()" src="assets/nav/nav-home-selected.svg"></svg-icon>
    <svg-icon class="nav-icon home parchment" [class.icon-hidden]="isHomeActive()" src="assets/nav/nav-home-unselected.svg"></svg-icon>
    <span class="nav-label">Home</span>
  </a>

  <!-- Score (smart routing: /score or /score/marginofsafety) -->
  <div class="nav-item"
       [class.active]="isScoreActive()"
       [style.--nav-accent]="'var(--color-sundown)'"
       (click)="navigateScore()"
       role="button"
       tabindex="0"
       (keyup.enter)="navigateScore()">
    <svg-icon class="nav-icon score parchment" [class.icon-hidden]="!isScoreActive()" src="assets/nav/nav-score-selected.svg"></svg-icon>
    <svg-icon class="nav-icon score parchment" [class.icon-hidden]="isScoreActive()" src="assets/nav/nav-score-unselected.svg"></svg-icon>
    <span class="nav-label">Score</span>
  </div>

  <!-- Play -->
  <a class="nav-item"
     routerLink="/plan-home"
     (click)="trackNavItem('/plan-home', 'BottomNavPlanClicked')"
     [class.active]="isPlayActive()"
     [style.--nav-accent]="'var(--color-wisteria)'">
    <svg-icon class="nav-icon play parchment" [class.icon-hidden]="!isPlayActive()" src="assets/nav/nav-play-selected.svg"></svg-icon>
    <svg-icon class="nav-icon play parchment" [class.icon-hidden]="isPlayActive()" src="assets/nav/nav-play-unselected.svg"></svg-icon>
    <span class="nav-label">Play</span>
  </a>

  <!-- Sanctuary -->
  <a class="nav-item"
     routerLink="/sanctuary"
     (click)="trackNavItem('/sanctuary', 'BottomNavSanctuaryClicked')"
     [class.active]="isRouteActive('/sanctuary')"
     [style.--nav-accent]="'var(--color-sagebrush)'">
    <svg-icon class="nav-icon sanctuary parchment" [class.icon-hidden]="!isRouteActive('/sanctuary')" src="assets/nav/nav-sanctuary-selected.svg"></svg-icon>
    <svg-icon class="nav-icon sanctuary parchment" [class.icon-hidden]="isRouteActive('/sanctuary')" src="assets/nav/nav-sanctuary-unselected.svg"></svg-icon>
    <span class="nav-label">Sanctuary</span>
  </a>

  <!-- Learn -->
  <a class="nav-item"
     routerLink="/learn"
     (click)="trackNavItem('/learn', 'BottomNavLearnClicked')"
     [class.active]="isRouteActive('/learn')"
     [style.--nav-accent]="'var(--color-camellia)'">
    <svg-icon class="nav-icon learn parchment" [class.icon-hidden]="!isRouteActive('/learn')" src="assets/nav/nav-learn-selected.svg"></svg-icon>
    <svg-icon class="nav-icon learn parchment" [class.icon-hidden]="isRouteActive('/learn')" src="assets/nav/nav-learn-unselected.svg"></svg-icon>
    <span class="nav-label">Learn</span>
  </a>

  <!-- Community -->
  <a class="nav-item"
     routerLink="/community"
     flipCoachTarget="community.mobile_menu"
     (click)="trackNavItem('/community', 'BottomNavCommunityClicked'); communityWelcome.onTargetUsed()"
     [class.active]="isRouteActive('/community')"
     [style.--nav-accent]="'var(--color-starlight)'">
    <svg-icon class="nav-icon community parchment" [class.icon-hidden]="!isRouteActive('/community')" src="assets/nav/nav-community-selected.svg"></svg-icon>
    <svg-icon class="nav-icon community parchment" [class.icon-hidden]="isRouteActive('/community')" src="assets/nav/nav-community-unselected.svg"></svg-icon>
    <span class="nav-label">Community</span>
  </a>
</nav>
